import { baseAxios } from "config";

export const getAssessmentById = async (id) => {
  //   try {
  const res = await baseAxios.get(`/assessments/${id}`);
  return res.data;
  //   } catch (err) {
  //     console.error(`Error fetching assessment:`, err);
  //     throw new Error(err.toString());
  //   }
};
